import {
  defaultSystemCode,
  exists,
  ReserveSpecifyBranchCode,
  ReserveSpecifyBranchCodeFromJSON,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat, dateToPlainFormat } from '@/utils'

export interface BibliographyRealDetailReserve {
  id: number
  rank: number
  userId: string
  name: string
  reserveRegistrationTime: string // 日付タイム
  collectionId: string
  preferredDate: string // 日付
  reserveExpiration: string // 日付？
  specifyBranchCodes: ReserveSpecifyBranchCode[]
  reserveSetId: number
  reserveSetRank: number
  reserveGroupId: number
  reserveRegistrationBranchCode: SystemCode
  reserveRegistrationPlaceCode: SystemCode
  forwardingBranchCode: SystemCode
  forwardingPlaceCode: SystemCode
  specifyCollectionId: string
  specifyCollectionNo: string
  reserveStatus: SystemCode
  reserveNoticeAllowed: boolean
  displayMemo: string
  contactMethod: SystemCode
  revision: number
}

export const defaultBibliographyRealDetailReserve = (): BibliographyRealDetailReserve => ({
  id: 0,
  rank: 0,
  userId: '',
  name: '',
  reserveRegistrationTime: '',
  collectionId: '',
  preferredDate: '',
  reserveExpiration: '',
  specifyBranchCodes: [],
  reserveSetId: 0,
  reserveSetRank: 0,
  reserveGroupId: 0,
  reserveRegistrationBranchCode: defaultSystemCode(),
  reserveRegistrationPlaceCode: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  forwardingPlaceCode: defaultSystemCode(),
  specifyCollectionId: '',
  specifyCollectionNo: '',
  reserveStatus: defaultSystemCode(),
  reserveNoticeAllowed: false,
  displayMemo: '',
  contactMethod: defaultSystemCode(),
  revision: 0
})

export function BibliographyRealDetailReserveFromJSON(
  json: any
): BibliographyRealDetailReserve {
  return {
    id: exists(json, 'id') ? json.id : 0,
    rank: exists(json, 'rank') ? json.rank : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    reserveRegistrationTime: exists(json, 'reserve_registration_time')
      ? dateTimeToPlainFormat(json.reserve_registration_time)
      : '',
    collectionId: exists(json, 'collection_id') ? json.collection_id : '',
    preferredDate: exists(json, 'preferred_date')
      ? dateToPlainFormat(json.preferred_date)
      : '',
    reserveExpiration: exists(json, 'reserve_expiration')
      ? dateToPlainFormat(json.reserve_expiration)
      : '',
    specifyBranchCodes: exists(json, 'specify_branch_codes')
      ? json.specify_branch_codes.map(ReserveSpecifyBranchCodeFromJSON)
      : [],
    reserveSetId: exists(json, 'reserve_set_id') ? json.reserve_set_id : 0,
    reserveSetRank: exists(json, 'reserve_set_rank')
      ? json.reserve_set_rank
      : 0,
    reserveGroupId: exists(json, 'reserve_group_id')
      ? json.reserve_group_id
      : 0,
    reserveRegistrationBranchCode: exists(
      json,
      'reserve_registration_branch_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_branch_code)
      : defaultSystemCode(),
    reserveRegistrationPlaceCode: exists(
      json,
      'reserve_registration_place_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_place_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    forwardingPlaceCode: exists(json, 'forwarding_place_code')
      ? SystemCodeFromJSON(json.forwarding_place_code)
      : defaultSystemCode(),
    specifyCollectionId: exists(json, 'specify_collection_id')
      ? json.specify_collection_id
      : '',
    specifyCollectionNo: exists(json, 'specify_collection_no')
      ? json.specify_collection_no
      : '',
    reserveStatus: exists(json, 'reserve_status')
      ? SystemCodeFromJSON(json.reserve_status)
      : defaultSystemCode(),
    reserveNoticeAllowed: exists(json, 'reserve_notice_allowed')
      ? json.reserve_notice_allowed
      : false,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    contactMethod: exists(json, 'contact_method')
      ? SystemCodeFromJSON(json.contact_method)
      : defaultSystemCode(),
    revision: json.revision
  }
}
